import OrbitProg from "../../../components/LoadingOrbit/OrbitProgress";
import EmojiTik from "../../../components/stikersComp/EmojiTik";

export default function LoadingPage() {
    return (
        <>
            <div className="flex mt-20 md:mt-8 ... justify-center items-center gap-4 ">
                <div>
                    {/* <a href="#" className="text-2xl  text-blue-800 font-extrabold text-primary flex items-center gap-2 whitespace-nowrap">
                      
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 dark:text-green-500 text-green-500 stroke-current" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M12 6L20 9l-8 3-8-3 8-3z" /><path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12" /><path strokeLinecap="round" strokeLinejoin="round" d="M20 12a8.1 8.1 0 01-8 8 8.1 8.1 0 01-8-8" /></svg>

                    </a> */}
                    {/* <EmojiTik /> */}

                </div>
                <div className="mt-20">
                    <OrbitProg />

                </div>
            </div>
        </>
    )
}